// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c1032c63","952":"5f855f64"}[chunkId] + ".chunk.js";
};